import React from 'react';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import CustomButton from '../../../components/buttons/CustomButton';
import personInitials from './personInitials';
import styles from './HealthRequestsBanner.module.css';

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR');
};

/**
 * Pedidos de acesso aos atendimentos que esperam o(a) Proprietário(a): quem
 * pediu, quando, e os botões de aprovar (liga a marcação) ou recusar (limpa o pedido).
 * Só aparece para o proprietário e só quando há pedido.
 */
function HealthRequestsBanner({ requests, busyUserId, onApprove, onDecline }) {
  if (!requests.length) return null;

  return (
    <section className={styles.banner} aria-label="Pedidos de acesso aos atendimentos">
      <header className={styles.header}>
        <span className={styles.icon}><MedicalServicesOutlinedIcon fontSize="small" /></span>
        <div>
          <h3 className={styles.title}>
            {requests.length === 1 ? 'Um pedido de acesso aos atendimentos' : `${requests.length} pedidos de acesso aos atendimentos`}
          </h3>
          <p className={styles.subtitle}>
            Quem você aprovar ganha a marcação Profissional de saúde e passa a abrir atendimentos, histórico e anexos.
          </p>
        </div>
      </header>
      <ul className={styles.list}>
        {requests.map((person) => {
          const busy = busyUserId === person.id;
          const since = formatDate(person.healthProfessionalRequestedAt);
          return (
            <li key={person.id} className={styles.row}>
              <span className={styles.avatar}>{personInitials(person.name || person.email)}</span>
              <div className={styles.identity}>
                <span className={styles.name}>{person.name || person.email}</span>
                <span className={styles.meta}>{since ? `Pediu em ${since}` : 'Pediu ao entrar na equipe'}</span>
              </div>
              <div className={styles.actions}>
                <CustomButton label="Recusar" variant="text" onClick={() => onDecline(person)} enabled={!busy} />
                <CustomButton
                  label="Aprovar acesso"
                  variant="contained"
                  style="main"
                  onClick={() => onApprove(person)}
                  enabled={!busy}
                  loading={busy}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default HealthRequestsBanner;
